import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, ShoppingBag, Star, Plus, Minus } from 'lucide-react';
import { useStore } from '../store/useStore';
export function QuickViewModal() {
  const {
    quickViewProduct,
    closeQuickView,
    addToCart
  } = useStore();
  const [selectedSize, setSelectedSize] = useState('M');
  const [quantity, setQuantity] = useState(1);
  if (!quickViewProduct) return null;
  return <AnimatePresence data-id="element-311">
      <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 md:p-6" data-id="element-312">
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={closeQuickView} className="absolute inset-0 bg-black/60 backdrop-blur-sm" data-id="element-313" />

        <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 10
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 10
      }} className="relative w-full max-w-3xl bg-white shadow-2xl overflow-hidden flex flex-col md:flex-row max-h-[90vh]" data-id="element-314">
          <button onClick={closeQuickView} className="absolute top-3 right-3 z-10 p-1.5 bg-white/80 hover:bg-white rounded-full transition-colors border border-gray-100" data-id="element-315">
            <X size={18} data-id="element-316" />
          </button>

          <div className="w-full md:w-[45%] aspect-square md:aspect-auto bg-gray-50" data-id="element-317">
            <img src={quickViewProduct.image} alt={quickViewProduct.name} className="w-full h-full object-cover" data-id="element-318" />
          </div>

          <div className="w-full md:w-[55%] p-6 md:p-10 flex flex-col overflow-y-auto" data-id="element-319">
            <div className="mb-4" data-id="element-320">
              <span className="text-gold text-[9px] uppercase tracking-[0.3em] font-bold block mb-1" data-id="element-321">
                {quickViewProduct.collection || 'TriLyn Collection'}
              </span>
              <h2 className="text-2xl font-serif mb-3 text-black leading-tight" data-id="element-322">
                {quickViewProduct.name}
              </h2>
              <div className="flex items-center gap-3 mb-3" data-id="element-323">
                <div className="flex text-gold" data-id="element-324">
                  {[...Array(5)].map((_, i) => <Star key={i} size={12} className="fill-gold text-gold" data-id="element-325" />)}
                </div>
                <span className="text-[9px] text-gray-400 uppercase tracking-widest font-bold" data-id="element-326">
                  24 Reviews
                </span>
              </div>
              <p className="text-xl font-serif text-gold" data-id="element-327">
                {quickViewProduct.salePrice || quickViewProduct.price}
              </p>
            </div>

            <p className="text-gray-500 text-xs leading-relaxed mb-6" data-id="element-328">
              A masterpiece of craftsmanship, this piece combines traditional
              African patterns with a modern silhouette.
            </p>

            <div className="space-y-5 mb-8" data-id="element-329">
              <div data-id="element-330">
                <label className="block text-[9px] uppercase tracking-widest font-bold mb-3 text-gray-400" data-id="element-331">
                  Select Size
                </label>
                <div className="flex gap-2" data-id="element-332">
                  {['S', 'M', 'L', 'XL'].map(size => <button key={size} onClick={() => setSelectedSize(size)} className={`w-10 h-10 border flex items-center justify-center text-[10px] font-bold transition-all ${selectedSize === size ? 'border-black bg-black text-white' : 'border-gray-200 hover:border-gold'}`} data-id="element-333">
                      {size}
                    </button>)}
                </div>
              </div>

              <div data-id="element-334">
                <label className="block text-[9px] uppercase tracking-widest font-bold mb-3 text-gray-400" data-id="element-335">
                  Quantity
                </label>
                <div className="flex items-center border border-gray-200 w-28 h-10" data-id="element-336">
                  <button onClick={() => setQuantity(Math.max(1, quantity - 1))} className="flex-1 h-full flex items-center justify-center hover:text-gold transition-colors" data-id="element-337">
                    <Minus size={14} data-id="element-338" />
                  </button>
                  <span className="flex-1 text-center font-bold text-xs" data-id="element-339">
                    {quantity}
                  </span>
                  <button onClick={() => setQuantity(quantity + 1)} className="flex-1 h-full flex items-center justify-center hover:text-gold transition-colors" data-id="element-340">
                    <Plus size={14} data-id="element-341" />
                  </button>
                </div>
              </div>
            </div>

            <div className="mt-auto pt-5 border-t border-gray-100" data-id="element-342">
              <button onClick={() => {
              addToCart(quickViewProduct, selectedSize);
              closeQuickView();
            }} className="w-full bg-black text-white py-3.5 text-[10px] uppercase tracking-[0.2em] font-bold hover:bg-gold transition-all duration-300 flex items-center justify-center gap-3 shadow-lg" data-id="element-343">
                <ShoppingBag size={16} data-id="element-344" /> Add to Bag
              </button>

              <button onClick={closeQuickView} className="w-full mt-3 text-[9px] uppercase tracking-widest font-bold text-gray-400 hover:text-black transition-colors" data-id="element-345">
                View Full Details
              </button>
            </div>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>;
}